<template>

    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-if="confirming.show">
        <div class="box-layout-inner alerts-banner">
            <div class="full-width blue">
                <div class="price-subtotal" id="confirm-edit">
                    <span class="text-center">
						<span id="confirm-message">
                        {{ confirming.message }}
						</span>
                        <a class="cta-button" v-for="option in confirming.options" :class="option.class" @click="(option.click != false ? option.click(true) : confirming = {show: false, message: '', options: [] } )" v-html="option.display"></a>
                    </span>
                </div>
            </div>
        </div>
    </div>
    <div class="form" v-else>
		<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
			<a class="cta-button" id="print-booking" @click="print()" v-if="basket.booking_items.length > 0 && basket.is_create_edit_callable == 'yes' && isOverview" v-html="'<i class=\'fa fa-print\'></i>'" key="printbooking"></a>
			<a class="cta-button" id="cancel-booking" @click="cancel()" v-if="basket.booking_items.length > 0 && basket.is_create_edit_callable == 'yes' && isOverview && !isThankyou" v-html="'<i class=\'fa fa-times\'></i>'" key="cancelbooking"></a>
			<a class="cta-button blue" id="edit-booking" @click="createEdit()" v-if="basket.booking_items.length > 0 && basket.is_create_edit_callable == 'yes' && isOverview && !isThankyou" v-html="'<i class=\'fa fa-pencil\'></i>'+locale.button_edit_booking" key="editbooking"></a>


        <thankyou v-if="isThankyou || isOverview" v-bind:booking_id="booking_id" v-bind:basket="basket"></thankyou>

		</div>


            <transition-group name="list">
                <booking-item @update="update" v-for="(participant, key) in basket.booking_items"  v-bind:editable="!isConfirmed && !isThankyou && !isOverview" v-bind:key="key" v-bind:booking_id="booking_id" v-bind:participant="participant"></booking-item>
            </transition-group>





        <transition name="slide-fade">

            <div v-if="!isConfirmed && basket.booking_items.length > 0 && (!isThankyou && !isOverview)" v-bind:key="0">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">

                    <router-link class="cta-button blue" id="add-other-children" :to="{ name: 'booking.age', params: { venueId: basket.booking_items[0].items[0].venue_id} }" v-html="locale.button_add_more_children" v-if="!isOverview && !isConfirmed"></router-link>

                    <div class="box-layout-inner blue">
                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <add-donation v-bind:outstanding_balance="basket.outstanding_balance" v-bind:donation_amount="basket.donation_amount" v-bind:booking_id="booking_id" @addeddonation="update" v-if="!isOverview && !isConfirmed"></add-donation>
                        </div>
                    </div>

                    <div class="box-layout-inner dark-blue financial-summary">

                            <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <apply-promo v-bind:existing_code="basket.promocode_applied" v-bind:booking_id="booking_id" @appliedpromo="update" v-if="!isOverview && !isConfirmed"></apply-promo>
                            </div>

                            <div class="col-xs-12 cart-totals" :class="{ 'col-sm-6 col-md-6 col-lg-6': !isOverview, 'col-sm-12 col-md-12 col-lg-12': isOverview }">

                                <div class="basket-subtotal" v-if="basket.fees.length > 0 || basket.discounts.length > 0">
                                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal price-original-total">
                                        <span class="vertical">{{ locale.text_original_total }}: </span>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal price-original-total">
                                        <b class="vertical">{{ currencyFormat(basket.original_cost) }}</b>
                                    </div>
                                </div>

                                <div class="fee-container" v-for="fee in basket.fees" v-if="fee.fee_amount != 0">
                                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box">
                                        <b>{{ (fee.description ? fee.description : fee.discount_blueprint.name) }}:</b>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box">
                                        <b>{{ currencyFormat((fee.fee_amount ? fee.fee_amount : fee.discount_amount)) }}</b>
                                    </div>
                                </div>

                                <div class="discount-container" v-for="discount in basket.discounts" v-if="discount.discount_amount != 0">
                                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box">
                                        <b>{{ (discount.description ? discount.description : discount.discount_blueprint.name ) }}:</b>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box">
                                        <b>- {{ currencyFormat(discount.discount_amount) }}</b>
                                    </div>
                                </div>

                                <div class="basket-subtotal" :class="{ 'large-single-total': basket.fees.length < 1 && basket.discounts.length < 1 &&basket.total_payments_received < 1 && basket.total_cost_minus_total_payments_received != null}" v-if="basket.outstanding_balance != null">
                                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal">
                                        <span class="vertical">{{ locale.text_total_cost }}: </span>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal">
                                        <b class="vertical">{{ currencyFormat(basket.total_cost) }}</b>
                                    </div>
                                </div>

                                <div class="discount-container" v-if="basket.total_payments_received > 0">
                                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 promo-box">
                                        <b>{{ locale.text_total_payments_received }}:</b>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 promo-box">
                                        <b>- {{ currencyFormat(basket.total_payments_received) }}</b>
                                    </div>
                                </div>

                                <div class="basket-total" v-if="basket.total_payments_received > 0 && basket.total_cost_minus_total_payments_received != null">
                                    <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8 price-subtotal">
                                        <span class="vertical">{{ ( basket.total_cost_minus_total_payments_received == basket.total_cost ? locale.text_total_cost : (basket.total_cost_minus_total_payments_received < 0 ? locale.text_refund_total : locale.text_outstanding_total ) ) }}: </span>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 price-subtotal">
                                        <b class="vertical">{{ currencyFormat(basket.total_cost_minus_total_payments_received) }}</b>
                                    </div>
                                </div>

                                <div class="checkout-cta" v-if="!isConfirmed && !isThankyou && !isOverview">
                                    <input v-if="!loading" type="button" class="cta-button red checkout" :class="{ 'disabled': false }" :disabled="false" @click="progress" :value="(basket.total_cost_minus_total_payments_received <= 0 && basket.original_booking_item != null ? 'Make Changes' : locale.button_basket_checkout)">
                                    <button class="cta-button red checkout disabled" disabled v-else><i class="fa fa-spinner fa-pulse"></i> &nbsp;Please wait</button>
                                </div>
                            </div>

                     </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" v-bind:key="3" v-else-if="basket.booking_items.length == 0">
                <p class="text-center" v-if="status == 'loading'"><i class="fa fa-spinner fa-pulse fa-5x dark"></i></p>
                <div class="box-layout-inner cart-empty" v-else-if="status == 'empty'">
                    <div class="title-block">
                        <p class="text-center">{{ locale.text_empty_basket }}</p>
                        <p class="text-center" style="margin:0 0 0 0;"><router-link :to="{ name: 'booking.age' }">{{ locale.text_empty_basket_line_2 }}</router-link></p>
                    </div>
                </div>
            </div>



        </transition>

        <transition name="slide-fade">
			<div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
				<div class="row" v-if="isConfirmed && basket.booking_items.length > 0 || isOverview">
					<payment-options :basket="basket"></payment-options>
				</div>
			</div>
        </transition>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                user_id: this.$root.auth.user_id,
                basket: {
                    booking_id: this.$root.getCookie('kingscamps_booking_id'),
                    original_booking_id: null,
                    booking_items: [],
                    discounts: [],
                    fees: [],
                    already_paid: 0,
                    donation_amount: null,
                },
                confirming: {
                    show: false,
                    message: '',
                    options: []
                },
                loading: false,
                status: "loading",
            }
        },
        components: {
            'thankyou': require('./Payment/PaymentConfirmation.vue'),
            'booking-item': require('./BasketItem.vue'),
            'apply-promo': require('./BasketPromo.vue'),
            'add-donation': require('./BasketDonation.vue'),
            'payment-options': require('./Payment/PaymentOptions.vue')
        },
        computed: {
            booking_id: function() {
                if(this.$route.params.hasOwnProperty('bookingId'))
                    return this.$route.params.bookingId;
                else if(this.$route.query.hasOwnProperty('bookingId'))
                    return this.$route.query.bookingId;
                else
                    return this.$root.getCookie('kingscamps_booking_id');
            },
            canEdit: function () {
                return this.basket.is_create_edit_callable == 'yes';
            },
            isConfirmed: function() {
                return this.$route.name == 'cart.payment';
            },
            isOverview: function() {
                return this.$route.name == 'account.bookings.view';
            },
            isThankyou: function() {
                return this.$route.query.hasOwnProperty('thankyou');
            },
            locale: function () {
                return this.$root.locale.basket;
            }
        },
        methods: {
            print: function () {
                window.print();
            },
            cancel: function (confirmed = false) {
                /**
                 * Checking whether the user has items in the basket that will get removed
                 */
                axios.get('/camp-booking/users/'+this.$root.auth.user_id+'/basket')
                    .then(response => {
                        if(response.data.data.number_of_items_in_basket > 0 && !confirmed) {
                            this.confirmEdit('cancel', response.data.data.number_of_items_in_basket);
                        } else {
                            if(this.booking_id != this.$root.getCookie('kingscamps_booking_id')) {
                                axios.post('/camp-booking/bookings/' + this.booking_id + '/create-edit', {
                                    auto_delete_items: true
                                }).then(response => {
                                    this.$root.setBookingId(response.data.data.booking_id);
                                    this.basket.booking_id = response.data.data.booking_id;

                                    this.$router.push({name: 'cart.payment', query: {bookingId: response.data.data.booking_id }});
                                }).catch(error => {
                                    this.$root.alert(error.response.data.data.message);
                                })
                            } else {
                                this.$router.push({name: 'cart.basket', query: {bookingId: this.booking_id}});
                            }
                        }
                    })
            },
            createEdit: function (confirmed = false) {
                /**
                 * Checking whether the user has items in the basket that will get removed
                 */
                axios.get('/camp-booking/users/'+this.$root.auth.user_id+'/basket')
                    .then(response => {
                        if(response.data.data.number_of_items_in_basket > 0 && !confirmed) {
                            this.confirmEdit('edit', response.data.data.number_of_items_in_basket);
                        } else {
                            if(this.booking_id != this.$root.getCookie('kingscamps_booking_id')) {
                                axios.post('/camp-booking/bookings/' + this.booking_id + '/create-edit', {
                                    auto_delete_items: false
                                }).then(response => {
                                    this.$root.setBookingId(response.data.data.booking_id);
                                    this.basket.booking_id = response.data.data.booking_id;

                                    this.$router.push({name: 'cart.basket', query: {bookingId: response.data.data.booking_id }});
                                }).catch(error => {
                                    this.$root.alert(error.response.data.data.message);
                                })
                            } else {
                                this.$router.push({name: 'cart.basket', query: {bookingId: this.booking_id}});
                            }
                        }

                    })
            },
            confirmEdit: function (type = 'edit', amount = null) {
                var submit = null;
                switch(type) {
                    case 'edit':
                        submit = this.createEdit;
                        break;
                    case 'cancel':
                        submit = this.cancel;
                        break;
                }
                this.confirming = {
                    show: true,
                    message: 'Are you sure you want to '+type+' this booking? This will remove the '+amount+' item that is already in your basket.',
                    options: [
                        { display: 'Yes', click: submit, class: 'red' },
                        { display: 'No', click: false, class: 'blue' }
                    ]
                }
            },
            progress: _.debounce(
                function () {

                    this.loading = true;
                    /**
                     * Checking the booking for any errors before continuing
                     **/
                    axios.get('/camp-booking/bookings/' + this.basket.booking_id + '/complete/check-for-errors?stage=basket')
                        .then(response => {
                            var errors = [];
                            response.data.data.forEach(collection => {
                                Object.keys(collection).map(key => { return collection[key]; }).forEach(section => {
                                    switch (typeof section) {
                                        case 'string':
                                            errors.push(section);
                                            break;
                                        case 'object':
                                            Object.keys(section).map(key => { return section[key]; }).forEach(error => errors.push(error));
                                            break;
                                    }
                                })
                            })

                            if (errors.length) {
                                this.$root.alert(errors);
                                this.loading = false;
                                return false
                            }

                            /**
                             * Needs the user to now confirm details before continuing
                             **/
                            var has_completed = false;
                            this.basket.booking_items.filter(collection => {
                                return collection.items.filter(item => {
                                    if (item.booking_item_state_id != 4) has_completed = true
                                })
                            });
                            if (has_completed)
                                this.$router.push({name: 'cart.details.confirm'});
                            else
                                this.$router.push({name: 'cart.payment'});
                        }).catch(error => {
                            this.loading = false;
                        })
                },
                500),
            currencyFormat: function ( value, show_minus = false) {
                return (value < 0 && show_minus ? '- ' : '') + this.basket.currency_unit + Math.abs(value).toFixed(2);
            },
            update: function () {

                //Google conversion tracking script
                if(this.isThankyou) {
                    // eval(this.$root.config.conversion_script_complete);
                }
                //Getting the booking details (packages, participants, costs, etc)
                if(this.$root.auth.user_id != null)
                    axios.get('/camp-booking/users/' + this.$root.auth.user_id + '/basket')
                        .then(response => {
                            this.basket.booking_id = response.data.data.booking_id;
                            this.basket.original_booking_item = response.data.data.origional_booking_id;
                        })

                setTimeout(() => {
                    var booking_id = (this.$route.params.hasOwnProperty('bookingId') ? this.$route.params.bookingId : ( this.$route.query.hasOwnProperty('bookingId') ? this.$route.query.bookingId : (this.basket.booking_id ? this.basket.booking_id : this.booking_id)));
                    if (booking_id != null && booking_id != "null")
                        axios.get('/camp-booking/bookings/' + booking_id)
                            .then(response => {

                                var participant_bookings = [];
                                Object.assign(this.basket, response.data.data);

                                //Calculating how much has already been paid
                                this.basket.already_paid = 0;
                                this.basket.payment_history.forEach(payment => {
                                    if (payment.payment_state_id == 3)//Completed state
                                        this.basket.already_paid += Math.abs(payment.payment_amount);
                                })

                                var basket = this.basket;
                                this.basket.original_cost = basket.total_cost;
                                this.basket.donation_amount = basket.donation_amount;
                                this.basket.booking_items.forEach(function (item) {
                                    let existing = participant_bookings[item.participant_id];
                                    participant_bookings[item.participant_id] = {
                                        full_name: item.participant_full_name,
                                        currency_unit: basket.currency_unit,
                                        items: ( existing ? existing['items'].concat([item]) : [item] )
                                    };
                                })

                                this.basket.fees.forEach(fee => {
                                    this.basket.original_cost -= fee.fee_amount;
                                });
                                this.basket.discounts.forEach(discount => {
                                    this.basket.original_cost += Math.abs(discount.discount_amount);
                                })

                                this.basket.booking_items = participant_bookings.filter(function () {
                                    return true;
                                });

                                /** Updating the basket count **/
                                this.$root.updateBasketCount();

                                if (this.basket.booking_items.length == 0)
                                    this.status = "empty";
                            }).catch(error => {
                            this.$root.alert('Could not find booking #' + booking_id + ', please pick a booking from below.');
                            this.$router.push({name: 'account.bookings'});
                        })
                    else
                        this.status = "empty";
                    this.loading = false;
                }, 500);
                /**
                 * Setting the headers
                 **/
                this.$root.headers = {

                    navigate: (this.isOverview ? {
                        name: (this.$route.query.payments ? 'account.payments' : 'account.bookings'),
                    } : null),
                    title: (this.isConfirmed ? this.$root.locale.miscellaneous.page_headings.cart.select_payment_method : (this.isThankyou ? this.$root.locale.miscellaneous.page_headings.cart.view_booking_payment_confirmation : (this.isOverview ? this.$root.locale.miscellaneous.page_headings.account.booking_overview : this.$root.locale.miscellaneous.page_headings.cart.view_basket))),
                    show_venue: false,
                    allow_change: false,
                }
                this.confirming = { show: false, message: "", options: [] };
            }
        },
        watch: {
            "$route": {
                handler: function () {
                    this.update();
                },
                deep: true
            }
        },
        created () {
            if(this.$route.query.hasOwnProperty('payment_failure')) {
                this.$root.alert('Something went wrong with payment. Please try again!');
                axios.post('/camp-booking/bookings/'+this.$route.query.booking_id+'/payment-failed')
                    .then(response => {
                        //console.log(response);
                        setTimeout(() => {
                            this.update();
                        }, 1000);
                    })

                axios.post('/camp-booking/bookings/'+this.$route.query.booking_id+'/create-edit')
                    .then(response => {
                        this.$root.setBookingId(response.data.data.booking_id);
                        this.basket.booking_id = response.data.data.booking_id;

                        setTimeout(() => {
                            this.update();
                        }, 1000);
                    })
            } else {
                this.$root.setBookingId();

                setTimeout(() => {
                    this.update();
                }, 1000);
            }
        }

    }
</script>



// WEBPACK FOOTER //
// Basket.vue?c9e494fa